module.exports = __webpack_public_path__ + "media/application/images/home/intro_images/feature_desert-182c0b9a83f6877d519dfb49dc268316.jpg";